import { ApiService, ConfigService } from '../../../shared/services';
import { LocationEmployeeLog, ClockDateFilter } from '../models';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ClockInOutService {
    baseUrl: string = this._configService.getContext('management').url;
    path: string = 'locations/mobile/check-in-out';

    locations: LocationEmployeeLog[] = [];

    constructor(private _configService: ConfigService,
                private _apiService: ApiService,
                ) { }

    getLocationEmployeeLogs(dateFilter?: ClockDateFilter): Observable<LocationEmployeeLog[]> {
        return this._apiService.get(this.baseUrl, this.path, dateFilter || null)
               .map(logs => logs.locations.map(locationEmployeesLog => new LocationEmployeeLog(locationEmployeesLog)))
               .cache();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/services/clock-in-out.service.ts